/*
 * Darf eine Lehrkraft die persönlichen Nachweise ihrer Schüler:innen an deren
 * Stelle hochladen? (Anforderung #94)
 *
 * Dieselbe Regel steht im Backend in
 * `services/companies/teacherDocumentUpload.js` — dort wird sie entschieden.
 * Hier steht sie, damit die Oberfläche den Reiter gar nicht erst anbietet, wo
 * er nichts bewirken würde, und damit die Einstellungen anzeigen können, was
 * gerade gilt.
 *
 * **Fehlt die Einstellung, gilt sie als aus.** Das ist die andere Richtung als
 * bei den Voraussetzungen der Checkliste (`shared/activationRequirements.js`),
 * wo ein fehlender Eintrag „gilt" heißt — und mit Absicht: Eine fehlende Zeile
 * darf keine Freigabe erteilen, die niemand vergeben hat.
 */

// Die Unternehmensformen, für die sich die Freigabe einstellen lässt.
export const TEACHER_UPLOAD_COMPANY_TYPES = ['JC', 'JCC', 'JBC']

export const readTeacherUploadConfig = options => ({
	active: options?.teacherDocumentUpload?.active === true,
	companyTypes: Array.isArray(options?.teacherDocumentUpload?.companyTypes)
		? options.teacherDocumentUpload.companyTypes
		: []
})

/**
 * Gilt die Freigabe für diese Unternehmensform?
 *
 * @param options      Die Options aus dem Store.
 * @param companyType  "JC" | "JCC" | "JBC" — ohne Angabe: nein.
 */
export const mayTeacherUpload = (options, companyType) => {
	const config = readTeacherUploadConfig(options)

	return config.active && Boolean(companyType) && config.companyTypes.includes(companyType)
}
